import React, { useState } from "react";
import { ClipLoader } from 'react-spinners';
import { post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import Layout from "./Shared/Layout";
import ServicesSection from "./HomePage/ServicesSection";

const ContactUs = () => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        EnquiryId: 0,
        Name: '',
        EmailId: '',
        ContactNo: '',
        Remark: '',
        Subject: '',
        CreatedBy: 0,
        IsActive: true
    });

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && parseInt(phone[0], 10);
        return isValid;
    };

    const validateEmail = (email) => {
        const isValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
        return isValid;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // if (name === 'ContactNo') {
        //     if (!/^[0-9]*$/.test(value)) {
        //         toast.error("Please enter only number for mobile number.");
        //         setLoading(false);
        //         return;
        //     }
        // }

        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const onSaveEnquiry = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!validateEmail(formData.EmailId)) {
            toast.error("Please enter a valid Email Address");
            setLoading(false);
            return;
        }

        if (!validatePhoneNumber(formData.ContactNo)) {
            toast.error("Please enter a valid mobile number");
            setLoading(false);
            return;
        }

        try {
            const response = await post(API_URL.SaveEnquiry, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.isSuccess === 200) {
                toast.success("Your enquiry has been submitted successfully!");
                setFormData({
                    EnquiryId: 0,
                    Name: '',
                    EmailId: '',
                    ContactNo: '',
                    Remark: '',
                    Subject: '',
                    CreatedBy: 0,
                    IsActive: true
                });
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <div className="container layout_main">
                <div className="page-header mb-3">
                    <h1>Contact Us</h1>
                </div>

                {/* Contact Details Section */}
                <section id="contact-page">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="contact-details d-flex justify-content-center align-items-center">
                                    <div className="text-center">
                                        <i className="fa fa-envelope" aria-hidden="true"></i>
                                        <h4 className="mb-0">Email Us</h4>
                                        <p>support@gailee.in</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="contact-details d-flex justify-content-center align-items-center">
                                    <div className="text-center">
                                        <i className="fa fa-location-pin" ></i>
                                        <h4>Location</h4>
                                        <p>4/766 Vibhav Khand, Gomtinagar, Lucknow - 226010</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="contact-details d-flex justify-content-center align-items-center">
                                    <div className="text-center">
                                        <i className="fa fa-phone"></i>
                                        <h4>Phone</h4>
                                        <p>+91 87565 62626</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="contact_sec">
                    <div className="container">
                        <div className="row contact-main">
                            <div
                                className="col-lg-5 aos-init aos-animate"
                                data-aos="fade-right"
                            >
                                <div className="map">
                                    <iframe
                                        title="Google Map"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.3784014931593!2d81.02009621168276!3d26.859716262267554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be2f2342aff11%3A0xbcf2f0d4e36bb2cb!2s4-766%2C%20Vibhav%20Khand%20-4%2C%20Vibhav%20Khand%2C%20Gomti%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226010!5e0!3m2!1sen!2sin!4v1744777958527!5m2!1sen!2sin"
                                        width="100%"
                                        height="450"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    >
                                    </iframe>
                                </div>
                            </div>

                            <div
                                className="col-lg-7 contact-form aos-init aos-animate pt-sm-0 pt-3"
                                data-aos="fade-left"
                            >
                                <div className="section-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <form onSubmit={onSaveEnquiry}>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Name*"
                                                name="Name"
                                                id="Name"
                                                required
                                                value={formData.Name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                className="form-control"
                                                type="email"
                                                placeholder="Email*"
                                                id="EmailId"
                                                name="EmailId"
                                                required
                                                value={formData.EmailId}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Phone No*"
                                                id="ContactNo"
                                                name="ContactNo"
                                                required
                                                value={formData.ContactNo}
                                                onChange={handleChange}
                                                maxLength={10}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Subject*"
                                                id="Subject"
                                                name="Subject"
                                                required
                                                value={formData.Subject}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <textarea
                                                className="textarea w-100"
                                                name="Remark"
                                                id="Remark"
                                                rows="5"
                                                placeholder="Message"
                                                required
                                                value={formData.Remark}
                                                onChange={handleChange}
                                            ></textarea>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <button
                                                className="btn-cstm web_buttons"
                                                disabled={loading}
                                                type='submit'
                                            >
                                                {loading ? (
                                                    <ClipLoader color="#fff" size={20} />
                                                ) : (
                                                    'Submit'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="mt-5">
                    <ServicesSection />
                </div>
            </div>
        </Layout>
    );
};

export default ContactUs;
